export const postCommentCommandErrors = ["CommentAlreadyExists"] as const;

export type PostCommentCommandError = typeof postCommentCommandErrors[number];
